import {Button, DialogActions, DialogContent, DialogTitle, TextField, Alert} from "@mui/material";
import {IntegrationProviderGrid} from "./IntegrationDesign";
import {SettingsDialogDescription} from "../SettingsDialog";
import React, {useEffect, useState} from "react";
import {sharedTrafficSourceService} from "../../../service/sharedTrafficSourceService";
import Spinner from "../../spinner/Spinner";
import {integrationActions} from "../../../store/actions/integrationAction";
import {connect} from "react-redux";

function ChooseTrafficSourceIntegration(props) {
    const [loading, setLoading] = useState(true);
    const [requestError, setRequestError] = useState("");
    const [templates, setTemplates] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    const integrations = ["Google Ads", "TikTok", "Facebook", "Microsoft Ads", "Taboola", "MGID", "Outbrain", "PropellerAds", "Pushground", "ExoClick", "Mondiad", "Revcontent", "Outbrain DSP", "NewsBreak", "SmartNews", "MediaGo", "Popin"];

    const handleChange = event => {
        setSearchQuery(event.target.value);
    };

    const filteredTemps = !searchQuery
        ? templates
        : templates?.filter(item =>
            item?.name?.toLowerCase().includes(searchQuery.toLocaleLowerCase())
        );

    useEffect(() => {
        async function fetchData() {
            setRequestError("");
            setLoading(true);
            await sharedTrafficSourceService.read().then((response) => {
                if (response !== null && response !== undefined) {
                    setTemplates(response?.sharedTrafficSources);
                }
            }).catch((error) => {
                if (error?.response?.data?.error) {
                    setRequestError(error.response.data.error);
                }
            }).finally(() => {
                setLoading(false);
            });
        }

        if (templates === null) {
            fetchData();
        }
    }, [templates]);

    const selectIntegration = (item) => {
        props.updateSelectedIntegration(item);
    };

    const handleCloseButton = () => {
        props.handleClose();
    };

    return (
        <><DialogTitle id="form-add-integration">Choose traffic source
                <SettingsDialogDescription>Connect an ad platform to sync costs and manage your campaigns.</SettingsDialogDescription>
            </DialogTitle>
            <DialogContent sx={{minHeight: 280, position: 'relative'}}>
                {loading && <Spinner overComponentBox noBackShadow/>}
                {requestError && <Alert severity="error" variant="filled" sx={{mb: 2}}>{requestError}</Alert>}
                <TextField variant="outlined" size="small" margin="dense" label="Search providers" name="traffic-source"
                    placeholder="Search by provider name" fullWidth slotProps={{inputLabel: {shrink: true}}}
                    value={searchQuery} onChange={handleChange}/>
                {!loading && !requestError && <IntegrationProviderGrid templates={filteredTemps?.filter(item => integrations.includes(item?.name))} onSelect={selectIntegration}/>}
            </DialogContent>
            <DialogActions><Button onClick={handleCloseButton} color="inherit">Cancel</Button></DialogActions></>
    );
}

const mapDispatchToProps = {
    updateSelectedIntegration: integrationActions.updateSelectedIntegration
};

export default connect(null, mapDispatchToProps)(ChooseTrafficSourceIntegration);
